import { Form } from 'formik'
import styled from 'styled-components'

export const FormikForm = styled(Form as any)`
  background-color: ${props => props.theme.colors.white};
  padding: 0;
`
